import createEscaper from './_createEscaper.js';
import unescapeMap from './_unescapeMap.js';

// Function for unescaping strings from HTML interpolation.
export default createEscaper(unescapeMap);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/unescape.js
// module id = 1612
// module chunks = 106